import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

// ======================== Listing ========================

export const Wo3010SearchParamsSchema = z
  .object({
    itemId: z.string().nullish(),
  })
  .merge(BasePaginateParamsSchema)

export type Wo3010SearchParams = z.infer<typeof Wo3010SearchParamsSchema>

export const Wo3010SearchResultModelSchema = z.object({
  id: z.number(),
  code: z.string(),
  isDefault: z.boolean(),
  itemId: z.number(),
})

export type Wo3010SearchResultModel = z.infer<
  typeof Wo3010SearchResultModelSchema
>

export const Wo3010SearchResultSchema = z
  .object({
    data: z.array(Wo3010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Wo3010SearchResult = z.infer<typeof Wo3010SearchResultSchema>
